<template>
  <v-card :to="`/shop/prints${getQuery()}`" outlined nuxt>
    <v-img
      :src="$asa.getImageUrl(photo, 'thumb')"
      :alt="`${photo.fullName} photography.`"
      :class="$vuetify.theme.dark ? 'dark' : ''"
      height="340"
      contain
      class="thumb-preview"
    />
    <v-card-text>
      <div class="d-flex align-center justify-space-between">
        <div v-if="isCategory">
          <h4 class="text-body-1 font-weight-bold">
            {{ photo.categoryName }}
          </h4>
        </div>
        <div v-else>
          <h4 class="text-body-1 font-weight-bold">
            {{ photo.title }}
          </h4>
          <h5 class="text-body-2">
            by <strong>{{ photo.photographerName }}</strong>
          </h5>
        </div>
        <div>
          <v-btn
            :to="`/shop/prints${getQuery()}`"
            nuxt
            depressed
            dark
            class="ma-0"
          >
            {{ isCategory ? 'Explore' : 'Buy' }}
          </v-btn>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'ShopPrintCard',
  props: {
    photo: {
      type: Object,
      default: () => {}
    },
    isCategory: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getQuery() {
      if (this.isCategory) {
        return `?category=${this.photo.categoryName}&cid=${this.photo.categoryId}&from=shop`
      }
      return `?id=${this.photo.id}&from=shop`
    }
  }
}
</script>

<style scoped>
.thumb-preview {
  background-color: #212121;
  border: 2px solid rgba(0, 0, 0, 0.54);
}
.thumb-preview.dark {
  background-color: #000;
}
</style>
